import { color as d3Color } from 'd3';

export function getRelativeLuminance(hexColor: string): number {
  const c = d3Color(hexColor);
  if (!c) return 0.5;

  const rgb = c.rgb();
  const r = rgb.r / 255;
  const g = rgb.g / 255;
  const b = rgb.b / 255;

  const toLinear = (x: number) =>
    // biome-ignore lint/style/useExponentiationOperator: migrated from develop
    x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);

  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
}

export function getContrastTextColor(
  bgColor: string,
  lightText = '#FFFFFF',
  darkText = '#2D426A',
  threshold = 0.4
): string {
  const L = getRelativeLuminance(bgColor);
  return L > threshold ? darkText : lightText;
}
